import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class ProfessionalService {
  static ENDPOINT = `${BASE}/professional`;

  static async create(professionalCreate, auth = false, registrationToken = null) {
    const headers = registrationToken ? { 'X-Registration-Token': registrationToken } : {};
    return await request({
      url: `${this.ENDPOINT}/`,
      method: 'POST',
      body: professionalCreate,
      headers,
      auth
    })
  }

  static async get(FK_Contact) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(FK_Contact)}`,
      headers: {'Accept': 'application/json'}
    })
  }

  static async update(id, professionalUpdate) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      method: 'PUT',
      body: professionalUpdate
    })
  }

  static async delete(FK_Contact) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(FK_Contact)}`,
      method: 'DELETE',
      headers: {'Accept': 'application/json'}
    })
  }
}

export default ProfessionalService;
